import React from 'react';
import { Image } from 'seduo-ui';
const Example = () => (<Image src="https://dummyimage.com/104x104/9fa4a8/fff.png" width="104px" height="104px" className="rounded-circle" alt="Martin Basl, Livesport, s.r.o., Business Development Manager"/>);
export default Example;
